module.exports = __webpack_public_path__ + "static/media/banner_royalgaming.89ba8db2.png";